export default __webpack_public_path__ + "static/media/oslobodjenje.ba3a0c7c.png";